import angular from 'angular';

module.exports = angular.module('common.filters.split', [])
.filter('split', function() {
  return function(value, delimeter) {
    delimeter = delimeter || '.';
    return value.toString().split(delimeter);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/split.js
 **/